import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, eur, errMsg } from "@/lib/api";

export default function AdminPricing() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/pricing/increase-preview").then((r) => setD(r.data));
  useEffect(() => {
    load();
  }, []);
  const apply = async () => {
    if (!window.confirm("Applicare definitivamente l'aumento del 4% a tutti i prezzi di vendita? L'operazione può essere eseguita una sola volta.")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/pricing/increase-apply");
      toast.success(`Prezzi aggiornati: ${data.updated} prodotti`);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  if (!d) return <div className="h-60 animate-pulse rounded-2xl bg-white/5" />;
  return (
    <div className="max-w-4xl" data-testid="admin-pricing-page">
      <h1 className="font-display text-3xl font-semibold">Aumento commerciale del 4%</h1>
      <p className="mt-2 text-sm text-slate-400">Nuovo prezzo = prezzo di vendita attuale × 1,04, arrotondato a due decimali. Sovrapprezzi delle varianti e prezzi barrati restano invariati. Stesso prezzo per tutti i metodi di pagamento.</p>
      {d.applied_at ? (
        <p className="mt-6 rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-4 text-sm text-emerald-200" data-testid="pricing-applied">Aumento già applicato il {new Date(d.applied_at).toLocaleString("it-IT")}. Non può essere ripetuto.</p>
      ) : (
        <div className="mt-6 flex flex-wrap items-center gap-4 rounded-xl border border-amber-400/30 bg-amber-400/10 p-4 text-sm text-amber-100">
          <span>Anteprima: {d.items.length} prodotti · somma listino {eur(d.total_before)} → {eur(d.total_after)}</span>
          <button onClick={apply} disabled={busy} className="ml-auto h-10 rounded-full bg-[#0066FF] px-5 font-medium text-white disabled:opacity-50" data-testid="pricing-apply-btn">Applica aumento</button>
        </div>
      )}
      {!d.applied_at && (
        <div className="mt-6 overflow-x-auto rounded-2xl border border-white/10">
          <table className="w-full min-w-[560px] text-sm" data-testid="pricing-preview-table">
            <thead className="bg-white/5 text-left text-xs text-slate-400"><tr><th className="p-3">Prodotto</th><th className="p-3">Attuale</th><th className="p-3">Nuovo</th><th className="p-3">Barrato</th></tr></thead>
            <tbody className="divide-y divide-white/5">
              {d.items.map((p) => <tr key={p.id}><td className="p-3">{p.name}</td><td className="p-3 font-mono">{eur(p.price)}</td><td className="p-3 font-mono text-[#7FB0FF]">{eur(p.new_price)}</td><td className="p-3 font-mono text-slate-500">{p.compare_price ? eur(p.compare_price) : "-"}</td></tr>)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
